import type { Plan } from 'features/signup/signup-types';
import { PlanType } from 'features/signup/signup-types';

export const FREE_PRICE = 'Free';

// annual plan codes are the monthly code plus this suffix, charged for 12 months upfront
export const ANNUAL_SUFFIX = '_annual';

export const MONTHS_IN_YEAR = 12;

export const TRIAL_PLAN: Plan = {
  features: [
    '30 days free',
    '5,000 queries',
    'Point and click training',
    'Authenticated extraction',
    'Interactive extraction',
    'Download images and files',
    'Capture screenshots',
    'CSV, Excel, JSON output',
    'Reporting',
    'API access and Webhooks',
    'E-mail and ticket support',
  ],
  label: 'Free Trial of Standard Plan (30 days)',
  price: FREE_PRICE,
  price_annual: FREE_PRICE,
  queries: 5000,
  value: PlanType.TRIAL,
};

export const PLANS: Record<PlanType, Plan> = {
  [PlanType.TRIAL]: TRIAL_PLAN,
  [PlanType.STARTER]: {
    // same features as the trial, minus the 30 free days
    features: TRIAL_PLAN.features.slice(1),
    label: 'Starter Plan Subscription',
    price: '$11 / month',
    price_annual: '$9 / month',
    queries: TRIAL_PLAN.queries,
    value: PlanType.STARTER,
  },
  [PlanType.STANDARD]: {
    features: [
      '50,000 queries',
      'Point and click training',
      'Authenticated extraction',
      'Interactive extraction',
      'Download images and files',
      'Overages at $7 per 1K',
      'CSV, Excel, JSON output',
      'Reporting',
      'E-mail and ticket support',
    ],
    label: 'Standard Plan Subscription',
    price: '$249 / month',
    price_annual: '$199 / month',
    queries: 50_000,
    value: PlanType.STANDARD,
  },
  [PlanType.PROFESSIONAL]: {
    features: [
      '200,000 queries',
      'Point and click training',
      'Authenticated extraction',
      'Interactive extraction',
      'Download images and files',
      'Overages at $3.50 per 1K',
      'Capture screenshots',
      'CSV, Excel, JSON output',
      'Access to premium proxies*',
      'Reporting',
      'API access and Webhooks',
      'E-mail, ticket and chat support',
    ],
    label: 'Professional Plan Subscription',
    price: '$499 / month',
    price_annual: '$399 / month',
    queries: 200_000,
    value: PlanType.PROFESSIONAL,
  },
  [PlanType.ADVANCED]: {
    features: [
      '500,000 queries',
      'Point and click training',
      'Authenticated extraction',
      'Interactive extraction',
      'Download images and files',
      'Overages at $2.50 per 1K',
      'Capture screenshots',
      'CSV, Excel, JSON output',
      'Access to premium proxies*',
      'Reporting',
      'API access and Webhooks',
      'E-mail, ticket, chat and phone support',
    ],
    label: 'Advanced Plan Subscription',
    price: '$899 / month',
    price_annual: '$699 / month',
    queries: 500_000,
    value: PlanType.ADVANCED,
  },
};

export const VALID_PLANS = Object.keys(PLANS);

export const SELECT_PLAN_ITEMS = Object.values(PLANS);
